// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (max-width: 768px) {
  .user-form-container {
    padding: 1rem;
  }
}
.user-form-container .toast {
  position: fixed;
  top: 1rem;
  right: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  color: white;
  font-weight: 500;
  z-index: 1000;
  animation: toast-slide-in 0.3s ease-out;
}
.user-form-container .toast.success {
  background-color: #10b981;
}
.user-form-container .toast.error {
  background-color: #ef4444;
}
.user-form-container .user-form-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  z-index: 1001;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.user-form-container .user-form-close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.user-form-container .user-form-close-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.modal-user-form-container {
  padding: 0rem !important;
}

.user-form-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: user-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .user-form-card {
    padding: 1rem;
    width: 100%;
  }
}
.user-form-card .user-form-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  text-align: center;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .user-form-card .user-form-title {
    font-size: 1.25rem;
  }
}
.user-form-card .modal-user-form-title {
  font-size: 1.3rem !important;
}
.user-form-card .user-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.user-form-card .warning-message {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  background-color: #fef3c7;
  border: 1px solid #f59e0b;
  border-left: 4px solid #f59e0b;
  border-radius: 0.375rem;
  color: #92400e;
  font-size: 0.875rem;
  line-height: 1.4;
}
.user-form-card .warning-message svg {
  flex-shrink: 0;
  margin-top: 0.125rem;
  width: 1rem;
  height: 1rem;
}

.modal-user-form-card {
  width: 100% !important;
}

.user-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
@media (max-width: 768px) {
  .user-form {
    gap: 1rem;
  }
}
.user-form .form-section:last-of-type {
  margin-bottom: 0;
}
.user-form .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.user-form .user-form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;
}
.user-form .user-form-group:last-child {
  margin-bottom: 0;
}
.user-form .user-form-group .user-form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.user-form .user-form-group .user-form-label .user-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.user-form .user-form-group .user-form-input,
.user-form .user-form-group .user-form-select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.user-form .user-form-group .user-form-input:focus,
.user-form .user-form-group .user-form-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.user-form .user-form-group .user-form-input:hover:not(:focus),
.user-form .user-form-group .user-form-select:hover:not(:focus) {
  border-color: #9ca3af;
}
.user-form .user-form-group .user-form-input::placeholder,
.user-form .user-form-group .user-form-select::placeholder {
  color: #9ca3af;
}
.user-form .user-form-group .user-form-input:disabled,
.user-form .user-form-group .user-form-select:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.user-form .user-form-group .user-form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.user-form .user-form-flex-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .user-form .user-form-flex-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.user-form .user-form-flex-row .user-form-col-half {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.user-form .user-form-flex-row .user-form-col-half .user-form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.user-form .user-form-flex-row .user-form-col-half .user-form-label .user-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.user-form .user-form-flex-row .user-form-col-half .user-form-input,
.user-form .user-form-flex-row .user-form-col-half .user-form-select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.user-form .user-form-flex-row .user-form-col-half .user-form-input:focus,
.user-form .user-form-flex-row .user-form-col-half .user-form-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.user-form .user-form-flex-row .user-form-col-half .user-form-input:hover:not(:focus),
.user-form .user-form-flex-row .user-form-col-half .user-form-select:hover:not(:focus) {
  border-color: #9ca3af;
}
.user-form .user-form-flex-row .user-form-col-half .user-form-input::placeholder,
.user-form .user-form-flex-row .user-form-col-half .user-form-select::placeholder {
  color: #9ca3af;
}
.user-form .user-form-flex-row .user-form-col-half .user-form-input:disabled,
.user-form .user-form-flex-row .user-form-col-half .user-form-select:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.user-form .user-form-flex-row .user-form-col-half .user-form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.user-form .visibility-section h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.user-form .visibility-section .visibility-toggles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
@media (max-width: 768px) {
  .user-form .visibility-section .visibility-toggles {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 0.75rem;
  }
}
.user-form .visibility-section .toggle-label {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  text-transform: capitalize;
}
.user-form .visibility-section .toggle-switch {
  position: relative;
  width: 50px;
  height: 24px;
  cursor: pointer;
}
.user-form .visibility-section .toggle-switch input {
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}
.user-form .visibility-section .toggle-switch input:checked + .slider {
  background-color: var(--primary-color);
}
.user-form .visibility-section .toggle-switch input:checked + .slider::before {
  transform: translateX(26px);
}
.user-form .visibility-section .toggle-switch input:focus + .slider {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.user-form .visibility-section .toggle-switch .slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d5db;
  border-radius: 24px;
  transition: all 0.3s ease;
}
.user-form .visibility-section .toggle-switch .slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.user-form .visibility-section .toggle-switch:hover .slider {
  background-color: #9ca3af;
}
input:checked + .user-form .visibility-section .toggle-switch:hover .slider {
  background-color: #2563eb;
}
.user-form .user-form-button-container {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .user-form .user-form-button-container {
    flex-direction: column;
  }
}
.user-form .user-form-button-container .user-form-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .user-form .user-form-button-container .user-form-btn {
    width: 100%;
  }
}
.user-form .user-form-button-container .user-form-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.user-form .user-form-button-container .user-form-btn.user-form-btn-save {
  background-color: var(--primary-color);
  color: white;
}
.user-form .user-form-button-container .user-form-btn.user-form-btn-save:focus {
  outline: none;
}
.user-form .user-form-button-container .user-form-btn.user-form-btn-save:hover {
  background-color: #005a9a;
}
.user-form .user-form-button-container .user-form-btn.user-form-btn-save:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.user-form .user-form-button-container .user-form-btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.user-form .user-form-button-container .user-form-btn-cancel:hover {
  background-color: #f8f9fa;
}

@keyframes user-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes toast-slide-in {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@media (max-width: 768px) {
  .user-form-container .user-form-card {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .user-form-container {
    padding: 0.5rem;
  }
  .user-form-container .user-form-card {
    padding: 0.75rem;
  }
  .user-form-container .user-form-card .user-form-title {
    font-size: 1.125rem;
  }
  .user-form-container .user-form-card .user-form .user-form-group .user-form-input,
  .user-form-container .user-form-card .user-form .user-form-group .user-form-select,
  .user-form-container .user-form-card .user-form .user-form-col-half .user-form-input,
  .user-form-container .user-form-card .user-form .user-form-col-half .user-form-select {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .user-form-container .user-form-card .user-form .user-form-button-container .user-form-btn {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
  .user-form-container .user-form-card .user-form .visibility-section .visibility-toggles {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 0.5rem;
  }
}
@media print {
  .user-form-container {
    background: white;
    padding: 0;
  }
  .user-form-container .user-form-card {
    box-shadow: none;
    border: 1px solid #000;
  }
  .user-form-container .user-form-button-container,
  .user-form-container .toast,
  .user-form-container .user-form-close-button {
    display: none;
  }
}
.user-form input:focus-visible,
.user-form select:focus-visible,
.user-form button:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
.user-form .toggle-switch input:focus-visible + .slider {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/forms/UserForm/UserForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAEE;EAVF;IAWI,aAAA;EACF;AACF;AAEE;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uCAAA;AAAJ;AAEI;EACE,yBAAA;AAAN;AAGI;EACE,yBAAA;AADN;AAME;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AAJJ;AAMI;EACE,yBAAA;EACA,cAAA;AAJN;AAOI;EACE,aAAA;EACA,6CAAA;AALN;;AAUA;EACE,wBAAA;AAPF;;AAWA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,0CAAA;EACA,UAAA;AARF;AAUE;EATF;IAUI,aAAA;IACA,WAAA;EAPF;AACF;AAUE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AARJ;AAUI;EAPF;IAQI,kBAAA;EAPJ;AACF;AAUE;EACE,4BAAA;AARJ;AAYE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAVJ;AAaE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAXJ;AAaI;EACE,cAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;AAXN;;AAgBA;EACE,sBAAA;AAbF;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAdF;AAgBE;EALF;IAMI,SAAA;EAbF;AACF;AAmBI;EACE,gBAAA;AAjBN;AAoBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AAlBN;AAuBE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AArBJ;AAuBI;EACE,gBAAA;AArBN;AAwBI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAtBN;AAwBM;EACE,cAAA;EACA,oBAAA;AAtBR;AA2BI;;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAzBN;AA2BM;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAxBR;AA2BM;;EACE,qBAAA;AAxBR;AA2BM;;EACE,cAAA;AAxBR;AA2BM;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAxBR;AA4BI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AA1BN;AA+BE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AA7BJ;AA+BI;EALF;IAMI,sBAAA;IACA,WAAA;EA5BJ;AACF;AA8BI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AA5BN;AA8BM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA5BR;AA8BQ;EACE,cAAA;EACA,oBAAA;AA5BV;AAgCM;;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA9BR;AAgCQ;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA7BV;AAgCQ;;EACE,qBAAA;AA7BV;AAgCQ;;EACE,cAAA;AA7BV;AAgCQ;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AA7BV;AAiCM;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AA/BR;AAsCI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AApCN;AAuCI;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AArCN;AAuCM;EANF;IAOI,4DAAA;IACA,YAAA;EApCN;AACF;AAuCI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AArCN;AAwCI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAtCN;AAwCM;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAtCR;AAwCQ;EACE,sCAAA;AAtCV;AAwCU;EACE,2BAAA;AAtCZ;AA0CQ;EACE,6CAAA;AAxCV;AA4CM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AA1CR;AA4CQ;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AA1CV;AA8CM;EACE,yBAAA;AA5CR;AA8CQ;EACE,yBAAA;AA5CV;AAmDE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAjDJ;AAmDI;EAPF;IAQI,sBAAA;EAhDJ;AACF;AAkDI;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAhDN;AAkDM;EAVF;IAWI,WAAA;EA/CN;AACF;AAiDM;EACE,mBAAA;EACA,YAAA;AA/CR;AAkDM;EACE,sCAAA;EACA,YAAA;AAhDR;AAkDQ;EACE,aAAA;AAhDV;AAkDQ;EACE,yBAAA;AAhDV;AAmDQ;EACE,yBAAA;EACA,cAAA;AAjDV;AAqDI;EACE,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAnDN;AAqDM;EACE,yBAAA;AAnDR;;AA0DA;EACE;IACE,UAAA;IACA,2BAAA;EAvDF;EA0DA;IACE,UAAA;IACA,wBAAA;EAxDF;AACF;AA2DA;EACE;IACE,UAAA;IACA,2BAAA;EAzDF;EA4DA;IACE,UAAA;IACA,wBAAA;EA1DF;AACF;AA8DA;EAEI;IACE,WAAA;EA7DJ;AACF;AAiEA;EACE;IACE,eAAA;EA/DF;EAiEE;IACE,gBAAA;EA/DJ;EAiEI;IACE,mBAAA;EA/DN;EAqEQ;;;;IAEE,iBAAA;IACA,oBAAA;EAjEV;EAsEQ;IACE,oBAAA;IACA,oBAAA;EApEV;EAyEQ;IACE,4DAAA;IACA,WAAA;EAvEV;AACF;AA+EA;EACE;IACE,iBAAA;IACA,UAAA;EA7EF;EA+EE;IACE,gBAAA;IACA,sBAAA;EA7EJ;EAgFE;;;IAGE,aAAA;EA9EJ;AACF;AAoFE;;;EAGE,0BAAA;EACA,mBAAA;AAlFJ;AAqFE;EACE,0BAAA;EACA,mBAAA;AAnFJ","sourcesContent":["// Main Container - Match ExpenseForm styling\n.user-form-container {\n  min-height: calc(100vh - 118px);\n  background: var(--grey-shade-three);\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n\n  // Toast styling\n  .toast {\n    position: fixed;\n    top: 1rem;\n    right: 1rem;\n    padding: 0.75rem 1rem;\n    border-radius: 0.375rem;\n    color: white;\n    font-weight: 500;\n    z-index: 1000;\n    animation: toast-slide-in 0.3s ease-out;\n\n    &.success {\n      background-color: #10b981;\n    }\n\n    &.error {\n      background-color: #ef4444;\n    }\n  }\n\n  // Close button for modal\n  .user-form-close-button {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    color: #6b7280;\n    cursor: pointer;\n    z-index: 1001;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.25rem;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background-color: #f3f4f6;\n      color: #374151;\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }\n}\n\n.modal-user-form-container {\n  padding: 0rem !important;\n}\n\n// Form Wrapper - Match ExpenseForm wrapper structure\n.user-form-card {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  animation: user-form-fade-in 0.3s ease-out;\n  width: 70%;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n    width: 100%;\n  }\n\n  // Title styling\n  .user-form-title {\n    font-size: 1.3rem;\n    font-weight: 500;\n    color: #374151;\n    text-align: center;\n    margin-bottom: 0.5rem;\n\n    @media (max-width: 768px) {\n      font-size: 1.25rem;\n    }\n  }\n\n  .modal-user-form-title {\n    font-size: 1.3rem !important;\n  }\n\n  // Divider styling\n  .user-form-divider {\n    border: none;\n    border-top: 1px solid #e5e7eb;\n    margin: 1.5rem 0;\n  }\n\n  .warning-message {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    margin-bottom: 1.5rem;\n    background-color: #fef3c7;\n    border: 1px solid #f59e0b;\n    border-left: 4px solid #f59e0b;\n    border-radius: 0.375rem;\n    color: #92400e;\n    font-size: 0.875rem;\n    line-height: 1.4;\n\n    svg {\n      flex-shrink: 0;\n      margin-top: 0.125rem;\n      width: 1rem;\n      height: 1rem;\n    }\n  }\n}\n\n.modal-user-form-card {\n  width: 100% !important;\n}\n\n// Form Content\n.user-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n\n  @media (max-width: 768px) {\n    gap: 1rem;\n  }\n\n  // Form sections - Match ExpenseForm structure\n  .form-section {\n    // margin-bottom: 1.5rem;\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n\n    h3 {\n      font-size: 1rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 1rem 0;\n      padding-bottom: 0.5rem;\n      border-bottom: 1px solid #e5e7eb;\n    }\n  }\n\n  // Form Groups\n  .user-form-group {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 0.5rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .user-form-label {\n      display: block;\n      margin-bottom: 0.5rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      color: #374151;\n\n      .user-form-required {\n        color: #ef4444;\n        margin-left: 0.25rem;\n      }\n    }\n\n    // Input styling to match ExpenseForm\n    .user-form-input,\n    .user-form-select {\n      width: 100%;\n      padding: 0.5rem;\n      border: 1px solid #d1d5db;\n      border-radius: 0.25rem;\n      font-size: 0.875rem;\n      font-family: inherit;\n      color: #374151;\n      background: #ffffff;\n      box-sizing: border-box;\n      height: 2.5rem;\n\n      &:focus {\n        outline: none;\n        border-color: #3b82f6;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n\n      &:hover:not(:focus) {\n        border-color: #9ca3af;\n      }\n\n      &::placeholder {\n        color: #9ca3af;\n      }\n\n      &:disabled {\n        background-color: #f9fafb;\n        color: #6b7280;\n        cursor: not-allowed;\n      }\n    }\n\n    .user-form-select {\n      appearance: none;\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n      background-position: right 0.5rem center;\n      background-repeat: no-repeat;\n      background-size: 1.5rem 1.5rem;\n      padding-right: 2.5rem;\n    }\n  }\n\n  // Two column layout for user form\n  .user-form-flex-row {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 0.5rem;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n\n    .user-form-col-half {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n\n      .user-form-label {\n        display: block;\n        margin-bottom: 0.5rem;\n        font-weight: 500;\n        font-size: 0.875rem;\n        color: #374151;\n\n        .user-form-required {\n          color: #ef4444;\n          margin-left: 0.25rem;\n        }\n      }\n\n      .user-form-input,\n      .user-form-select {\n        width: 100%;\n        padding: 0.5rem;\n        border: 1px solid #d1d5db;\n        border-radius: 0.25rem;\n        font-size: 0.875rem;\n        font-family: inherit;\n        color: #374151;\n        background: #ffffff;\n        box-sizing: border-box;\n        height: 2.5rem;\n\n        &:focus {\n          outline: none;\n          border-color: #3b82f6;\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n        }\n\n        &:hover:not(:focus) {\n          border-color: #9ca3af;\n        }\n\n        &::placeholder {\n          color: #9ca3af;\n        }\n\n        &:disabled {\n          background-color: #f9fafb;\n          color: #6b7280;\n          cursor: not-allowed;\n        }\n      }\n\n      .user-form-select {\n        appearance: none;\n        background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n        background-position: right 0.5rem center;\n        background-repeat: no-repeat;\n        background-size: 1.5rem 1.5rem;\n        padding-right: 2.5rem;\n      }\n    }\n  }\n\n  // Visibility section styling\n  .visibility-section {\n    h3 {\n      font-size: 1.125rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 1rem 0;\n      padding-bottom: 0.5rem;\n      border-bottom: 1px solid #e5e7eb;\n    }\n\n    .visibility-toggles {\n      display: grid;\n      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n      gap: 1rem;\n      margin-top: 1rem;\n\n      @media (max-width: 768px) {\n        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n        gap: 0.75rem;\n      }\n    }\n\n    .toggle-label {\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n      font-size: 0.875rem;\n      font-weight: 500;\n      color: #374151;\n      text-transform: capitalize;\n    }\n\n    .toggle-switch {\n      position: relative;\n      width: 50px;\n      height: 24px;\n      cursor: pointer;\n\n      input {\n        opacity: 0;\n        position: absolute;\n        width: 0;\n        height: 0;\n\n        &:checked + .slider {\n          background-color: var(--primary-color);\n          \n          &::before {\n            transform: translateX(26px);\n          }\n        }\n\n        &:focus + .slider {\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n        }\n      }\n\n      .slider {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: #d1d5db;\n        border-radius: 24px;\n        transition: all 0.3s ease;\n\n        &::before {\n          content: '';\n          position: absolute;\n          height: 18px;\n          width: 18px;\n          left: 3px;\n          top: 3px;\n          background-color: white;\n          border-radius: 50%;\n          transition: all 0.3s ease;\n          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n        }\n      }\n\n      &:hover .slider {\n        background-color: #9ca3af;\n\n        input:checked + & {\n          background-color: #2563eb;\n        }\n      }\n    }\n  }\n\n  // Form actions to match ExpenseForm\n  .user-form-button-container {\n    display: flex;\n    justify-content: end;\n    gap: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e5e7eb;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n    }\n\n    .user-form-btn {\n      padding: 0.75rem 1.5rem;\n      border: none;\n      border-radius: 0.375rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      cursor: pointer;\n      min-width: 120px;\n      transition: all 0.2s ease;\n\n      @media (max-width: 768px) {\n        width: 100%;\n      }\n\n      &:disabled {\n        cursor: not-allowed;\n        opacity: 0.6;\n      }\n\n      &.user-form-btn-save {\n        background-color: var(--primary-color);\n        color: white;\n\n        &:focus {\n          outline: none;\n        }\n        &:hover{\n          background-color: #005a9a;\n        }\n\n        &:disabled {\n          background-color: #d1d5db;\n          color: #9ca3af;\n        }\n      }\n    }\n    .user-form-btn-cancel {\n      padding: 8px 16px;\n      border: 1px solid #ddd;\n      background: white;\n      color: #666;\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 14px;\n\n      &:hover {\n        background-color: #f8f9fa;\n      }\n      }\n  }\n}\n\n// Animations\n@keyframes user-form-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes toast-slide-in {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n// Responsive design improvements\n@media (max-width: 768px) {\n  .user-form-container {\n    .user-form-card {\n      width: 100%;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .user-form-container {\n    padding: 0.5rem;\n\n    .user-form-card {\n      padding: 0.75rem;\n\n      .user-form-title {\n        font-size: 1.125rem;\n      }\n\n      .user-form {\n        .user-form-group,\n        .user-form-col-half {\n          .user-form-input,\n          .user-form-select {\n            padding: 0.375rem;\n            font-size: 0.8125rem;\n          }\n        }\n\n        .user-form-button-container {\n          .user-form-btn {\n            padding: 0.5rem 1rem;\n            font-size: 0.8125rem;\n          }\n        }\n\n        .visibility-section {\n          .visibility-toggles {\n            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n            gap: 0.5rem;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Print styles\n@media print {\n  .user-form-container {\n    background: white;\n    padding: 0;\n\n    .user-form-card {\n      box-shadow: none;\n      border: 1px solid #000;\n    }\n\n    .user-form-button-container,\n    .toast,\n    .user-form-close-button {\n      display: none;\n    }\n  }\n}\n\n// Focus visible improvements for accessibility\n.user-form {\n  input:focus-visible,\n  select:focus-visible,\n  button:focus-visible {\n    outline: 2px solid #3b82f6;\n    outline-offset: 2px;\n  }\n\n  .toggle-switch input:focus-visible + .slider {\n    outline: 2px solid #3b82f6;\n    outline-offset: 2px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
